import { ShieldCheck, Info } from "lucide-react";
import { IDS } from "@/constants/testIds";
import Reveal from "@/components/site/Reveal";

const RESERVED = ["ISO", "FSC", "BRCGS", "SGS", "FDA"];

export default function Certifications() {
  return (
    <section
      id="certifications"
      data-testid={IDS.certsSection}
      className="relative py-20 sm:py-24 bg-white border-b border-line"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10">
          <div className="max-w-2xl">
            <span className="text-xs uppercase tracking-[0.25em] font-semibold text-brand">
              Certifications
            </span>
            <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-ink">
              Sourced from certified manufacturing partners.
            </h2>
          </div>
          <p className="text-sm text-mist max-w-md flex items-start gap-2">
            <Info className="h-4 w-4 mt-0.5 text-brand shrink-0" />
            Products are sourced from certified manufacturing partners wherever applicable. Actual certifications will be displayed only after verification.
          </p>
        </Reveal>

        <Reveal className="grid grid-cols-2 sm:grid-cols-5 gap-3 sm:gap-4">
          {RESERVED.map((r) => (
            <div
              key={r}
              className="aspect-[3/2] rounded-2xl border border-dashed border-line bg-cream flex flex-col items-center justify-center text-center px-4 grayscale hover:grayscale-0 hover:border-brand/40 transition-all duration-500"
            >
              <ShieldCheck className="h-6 w-6 text-brand" strokeWidth={1.6} />
              <div className="mt-2 font-heading font-semibold text-lg text-ink">
                {r}
              </div>
              <div className="text-[10px] uppercase tracking-widest text-mist">
                Reserved
              </div>
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
